






















import { defineComponent } from '@vue/composition-api';

const StatsPanel = defineComponent({
  props: {
    label: {},
    icon: {},
    secondaryText: {},
    secondaryIcon: {},
    primaryColor: { type: String, default: 'primary' },
    secondaryColor: { type: String, default: 'gray' },
    secondaryTextColor: {},
  },
  // setup() {},
});

export default StatsPanel;
